import Lock from '../icons/Lock';

export default function ProducerText() {
  return (
    <div className='mt-4 mb-2 flex flex-row'>
      <div className='min-w-8'>
        <Lock className='mr-4' width={24} height={28} />
      </div>

      <div className='flex flex-col'>
        <p className='lh-8'>
          Precisamos dessas informações para garantir a segurança das suas transações, cumprir exigências fiscais e
          permitir o repasse correto dos valores das suas vendas.
        </p>

        <p className='text-xs'>
          Todas as informações são protegidas e usadas apenas para fins de verificação e comunicação importante sobre
          suas vendas.
        </p>
      </div>
    </div>
  );
}
